<template>
    <v-row>
        <v-col>
            <v-simple-table>
                <thead>
                    <tr>
                        <th class="text-left">
                            Author
                        </th>
                        <th class="text-left">
                            Level
                        </th>
                        <th class="text-left">
                            Answer
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="result in results" :key="result.id">
                        <td class="text-center">
                            <router-link :to="{ name: 'work', 'params': { 'id': result.id }}">{{result.anon_author}}</router-link>
                        </td>
                        <td class="text-center">
                            <router-link :to="{ name: 'work', 'params': { 'id': result.id }}">{{result.level}}</router-link>
                        </td>
                        <td>
                            <router-link :to="{ name: 'work', 'params': { 'id': result.id }}">{{result.answer0.substr(0, 200)}}</router-link>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ['results']
}
</script>